const IMTheme = {
  colors: {
    primary: '#0077CC',
    secondary: '#E5F4FF',
    disabled: '#B0B0B0',
    text: '#000000',
    blue: '#CCEAFF',
    gray: '#E6E6E6',
    darkGray: '#666666',
    darkerGray: '#777777',
  },
  spacing: [2, 4, 8, 12, 16, 24, 32, 56],
  fontSizes: [10, 12, 14, 16, 18, 20, 22, 24],
  fontWeights: {
    light: 300,
    normal: 400,
    bold: 700,
  },
  boxShadows: {
    default: '0px 0px 8px rgba(0, 0, 0, 0.08)',
    focused: '0px 0px 8px rgba(0, 0, 0, 0.16)',
  },
}

export default IMTheme
